<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15hvwGg/tc-custom/9781788638647.jpg?1702093262042" alt="This image is the cover for the book Carthage, The Punic Wars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carthage, The Punic Wars
      </h1>
      <p class="bookDescription body article font2">
        <p>The final, devastating instalment in Ross Leckie’s extraordinary trilogy.</p><p>After 300 years of acrimony and two bitter wars, the great Mediterranean powers of Rome and Carthage are readying their blades once more.</p><p>Like their fathers before them, <b>Hanno Barca</b> and <b>Scipio Minor</b>, the sons of the legendary generals <b>Hannibal</b> and <b>Scipio Africanus</b>, must face off to decide the future of an empire.</p><p>When the ashes settle, once this final, fateful clash has ended... a nation will be no more.</p><p><b>An epic, masterful tale of power, love, pain and loss, perfect for fans of Robert Fabbri, Simon Scarrow and <i>I, Claudius</i>.</b></p>Praise for Ross Leckie<p>‘By turns lucid, enlightening and thrilling, this is the historical novel at its best’ <i>Historical Novel Society</i></p><p>‘A fine achievement, a thoughtful and stylish piece of historical fiction’ <i>Daily Telegraph</i></p><p>‘Breathtaking. Leckie brings the battle-tactics and manoeuvres almost cinematically alive and the sense of blood and sweat, chaos and horror, linger powerfully on … utterly gripping’ <i>The Scotsman</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ross Leckie
      </h2>
      
      <p class="authorDescription body article"><P>Ross Leckie is a Scottish author of historical novels, best known for his critically acclaimed Carthage trilogy.</P><P>He attended Corpus Christi College at Oxford University, and has worked variously as a farm labourer, roughneck, schoolmaster and insurance broker.</P><P>He has ten children, and now lives in Edinburgh</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e98b57c